import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import DropdownWithLabel from 'components/DropdownWithLabel'
import { filterOptions } from 'consts'
import { T, useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'
import './index.scss'

const TOLGEE_PREFIX = 'GenerateWinninAIReportUseCaseModal-CreatorsSearchContent'

export default function CreatorsSearchContent({ formValues, setFormValues }) {
  const t = useTranslate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const providersParam = searchParams.getAll('providers')
  const hasMoreThanOneProvider = providersParam?.length > 1
  const defaultProviderValue =
    !providersParam?.length || hasMoreThanOneProvider ? filterOptions.providers[0].value : providersParam.toString()
  const providersFromPlan = UserStore.providers ?? []

  function handleSelectProvider(value) {
    setFormValues(prevState => ({ ...prevState, outputProviders: [value] }))
  }

  const providerOptions = filterOptions.providers.map(provider => ({
    label: provider.label,
    isSelected: provider.value === (formValues?.outputProviders?.[0] ?? defaultProviderValue),
    isDisabled: !providersFromPlan.includes(provider.value),
    disabledMessage: t(TOLGEE_GLOBALS.disabledOptionUpgradePlan),
    onClick: () => handleSelectProvider(provider.value),
  }))

  const TIERS = useMemo(
    () => [
      {
        label: t({ key: `${TOLGEE_PREFIX}-icon`, defaultValue: 'Icon Creators' }),
        value: 'icon',
        description: t({ key: `${TOLGEE_PREFIX}-iconDescription`, defaultValue: '5M+ Followers/Subscribers' }),
      },
      {
        label: t({ key: `${TOLGEE_PREFIX}-top`, defaultValue: 'Top Creators' }),
        value: 'top',
        description: t({ key: `${TOLGEE_PREFIX}-topDescription`, defaultValue: '1M to 5M Followers/Subscribers' }),
      },
      {
        label: t({ key: `${TOLGEE_PREFIX}-mid`, defaultValue: 'Mid Creators' }),
        value: 'mid',
        description: t({ key: `${TOLGEE_PREFIX}-midDescription`, defaultValue: '200K to 1M Followes/Subscribers' }),
      },
      {
        label: t({ key: `${TOLGEE_PREFIX}-micro`, defaultValue: 'Micro Creators' }),
        value: 'micro',
        description: t({ key: `${TOLGEE_PREFIX}-microDescription`, defaultValue: 'Up to 200K Followes/Subscribers' }),
      },
    ],
    [t]
  )

  const creatorTierOptions = TIERS.map(tier => ({
    label: tier.label,
    isSelected: tier.value === formValues.tier,
    onClick: () => setFormValues(prevState => ({ ...prevState, tier: tier.value })),
    description: tier.description,
  }))

  useEffect(() => {
    const initialFormValues = {
      outputProviders: [defaultProviderValue],
      tier: 'icon',
    }

    setFormValues(prevState => ({ ...prevState, ...initialFormValues }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <p className="CreatorsSearchContent-text">
        <T keyName={`${TOLGEE_PREFIX}-description`}>
          Encontre oportunidades rapidamente com insights baseados em dados e economize seu tempo fazendo análises!
        </T>
      </p>
      <div className="CreatorsSearchContent-dropdownsContainer">
        <DropdownWithLabel
          label={t({
            key: `${TOLGEE_PREFIX}-tier`,
            defaultValue: 'Tier do Criador',
          })}
          options={creatorTierOptions}
        />
        <DropdownWithLabel label={t(TOLGEE_GLOBALS.providerTitle)} options={providerOptions} />
      </div>
    </>
  )
}
